import script from "./TemplateViewerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateViewerModal.vue?vue&type=script&setup=true&lang=js"

import "./TemplateViewerModal.vue?vue&type=style&index=0&id=6a69b016&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a69b016"]])

export default __exports__